<template>
  <div class="top-search">
    <div v-if="hasInput" class="search" :class="'theme-' + theme">
      <van-search
        v-model="curTopSearchMap.keyWord"
        placeholder="请输入搜索关键词"
        show-action
        :clearable="false"
        @search="search"
      >
        <template #action>
          <div @click="search">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="tab" :class="'theme-' + theme">
      <van-tabs
        v-model="curTopSearchMap.type"
        :color="theme === 'night' ? '#fff' : '#000'"
        background="transparent"
        :title-active-color="theme === 'night' ? '#fff' : '#000'"
        title-inactive-color="#999"
        @change="typeChange"
      >
        <van-tab
          v-for="(item, index) in tabsData"
          :key="index"
          :title="item.name"
          :name="item.value"
          >{{ item.name }}</van-tab
        >
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopSearch',
  props: {
    theme: {
      type: String,
      default: 'night'
    },
    hasInput: {
      type: Boolean,
      default: true
    },
    tabsData: {
      type: Array,
      default: () => []
    },
    topSearchMap: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curTopSearchMap: {
        keyWord: '',
        type: ''
      }
    }
  },
  watch: {
    topSearchMap: {
      handler(val) {
        this.curTopSearchMap = { ...this.topSearchMap }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.curTopSearchMap = { ...this.topSearchMap }
  },
  methods: {
    search(val) {
      console.log(val)
      this.$emit('search', { ...this.curTopSearchMap })
    },
    typeChange(val) {
      console.log(val)
      // this.keyWord = ''
      this.$emit('typeChange', { ...this.curTopSearchMap })
    }
  }
}
</script>

<style scoped lang="less">
.top-search {
  /deep/.search {
    margin-bottom: 7px;
    .van-search {
      background: transparent;
      padding: 0;
      border-bottom: 2px solid #fff;
      .van-search__content {
        background: transparent;
        // border-bottom: 2px solid #fff;
        border-radius: 0;
        padding-left: 0;
        .van-cell,
        .van-field__control {
          color: #999;
          font-size: 16px;
          line-height: 40px;
          padding: 0;
        }
        .van-cell {
          .van-field__left-icon {
            .van-icon {
              font-size: 22px;
            }
          }
          .van-cell__value {
            .van-field__body {
              // .van-icon_clear::after {
              //   font-size: 24px;
              //   display: inline-block;
              //   background: transparent;
              // }
            }
          }
        }
      }
      .van-search__action {
        color: #fff;
      }
    }
  }
  /deep/.tab {
    .van-tabs {
      .van-tabs__wrap {
        .van-tabs__nav {
          // padding-bottom: 0;
          .van-tab {
            padding: 0;
            line-height: 35px;
            font-size: 16px;
          }
          .van-tabs__line {
            height: 1.5px;
            width: calc(100% / 5);
          }
        }
      }
      .van-tabs__content {
        display: none;
      }
    }
  }
  /deep/.search.theme-night {
    // margin-bottom: 7px;
    .van-search {
      // background: transparent;
      // padding: 0;
      border-bottom: 2px solid #fff;
      .van-search__content {
        // background: transparent;
        // border-bottom: 2px solid #fff;
        // border-radius: 0;
        // padding-left: 0;
        .van-cell,
        .van-field__control {
          color: #999;
          // font-size: 16px;
          // line-height: 40px;
          // padding: 0;
        }
        .van-cell {
          .van-field__left-icon {
            .van-icon {
              // font-size: 22px;
            }
          }
          .van-cell__value {
            .van-field__body {
              // .van-icon_clear::after {
              //   font-size: 24px;
              //   display: inline-block;
              //   background: transparent;
              // }
            }
          }
        }
      }
      .van-search__action {
        color: #fff;
      }
      .van-search__action:active {
        background: #000;
      }
    }
  }
  /deep/.search.theme-day {
    // margin-bottom: 7px;
    .van-search {
      // background: transparent;
      // padding: 0;
      border-bottom: 2px solid #000;
      .van-search__content {
        // background: transparent;
        // border-bottom: 2px solid #000;
        // border-radius: 0;
        // padding-left: 0;
        .van-cell,
        .van-field__control {
          color: #000;
          // font-size: 16px;
          // line-height: 40px;
          // padding: 0;
        }
        .van-cell {
          .van-field__left-icon {
            .van-icon {
              // font-size: 22px;
            }
          }
          .van-cell__value {
            .van-field__body {
              // .van-icon_clear::after {
              //   font-size: 24px;
              //   display: inline-block;
              //   background: transparent;
              // }
            }
          }
        }
      }
      .van-search__action {
        color: #000;
      }
    }
  }
}
</style>
